/*
 Copyright 2016-2021 the original author or authors from the JHipster project.

 This file is part of the JHipster project, see https://www.jhipster.tech/
 for more information.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'jhi-metrics-endpoints-requests',
  template: `
    <h3>Endpoints requests (time in millisecond)</h3>
    @if (!updating) {
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Method</th>
              <th>Endpoint url</th>
              <th class="text-right">Count</th>
              <th class="text-right">Mean</th>
            </tr>
          </thead>
          <tbody>
            @for (entry of endpointsRequestsMetrics | keys; track entry) {
              @for (method of entry.value | keys; track method) {
                <tr>
                  <td>{{ method.key }}</td>
                  <td>{{ entry.key }}</td>
                  <td class="text-right">{{ method.value.count }}</td>
                  <td class="text-right">{{ method.value.mean | number: '1.0-3' }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  `,
  standalone: false,
})
export class JhiMetricsEndpointsRequestsComponent {
  /**
   * object containing service related metrics
   */
  @Input() endpointsRequestsMetrics: {};

  /**
   * boolean field saying if the metrics are in the process of being updated
   */
  @Input() updating: boolean;
}
